<template>
  <div v-if="only_online" class="card-wrap" :class="class_obj">
    <div class="card-header" @click="gotokd4page">
      <div class="card-header-left">
        <span class="iconfont icon-bushuitubiao card-icon"></span>
        <span class="card-name">{{ devdata.udname }}</span>
        <span class="card-group-tag">{{ devdata.group }}</span>
      </div>
      <div class="card-header-right">
        <span class="card-status-dot" :class="devdata.status === '在线' ? 'dot-online' : 'dot-offline'"></span>
        <span class="card-status-text">{{ devdata.status }}</span>
      </div>
    </div>

    <div v-if="show_simple === false" class="card-body" @click="gotokd4page">
      <div class="card-row">
        <span class="row-label">当前状态</span>
        <span class="row-value" :class="stClass">{{ stName }}</span>
      </div>
      <div class="card-row card-row--last">
        <span class="row-label">水位</span>
        <span class="row-value" :class="levelClass">{{ levelName }}</span>
      </div>
      <div v-if="faultName" class="card-row card-row--last">
        <span class="row-label">故障</span>
        <span class="row-value row-value--danger">{{ faultName }}</span>
      </div>
    </div>

    <div class="card-footer">
      <div class="footer-left">
        <span v-if="show_id" class="footer-id">ID: {{ devdata.did }}</span>
        <span class="footer-time">更新时间：{{ devdata.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/* 顶部状态文字（开发说明 V1.1 §20"小程序状态"表，st 对应 app_protocol.h APP_ST_* 0~11） */
const ST_NAMES = [
  "正在初始化水路",   // 0 开机BC校准（剩余10秒）
  "待机",             // 1 BC待机
  "维护模式",         // 2 维护空闲
  "",                 // 3 排水前检查（瞬时状态，§20 未定义，不显示）
  "正在切换排水水路", // 4 排水前灌水（剩余3秒）
  "正在排水",         // 5 AB排水
  "正在切换补水水路", // 6 正常切换BC（剩余10秒）
  "正在自动补水",     // 7 自动换水补水
  "正在手动补水",     // 8 按键或平台补水
  "正在补充蒸发水",   // 9 独立补水
  "正在初始化水路",   // 10 强制安全回BC（剩余15秒）
  "故障",             // 11 故障锁定
];

const LEVEL_NAMES = ["满水", "半水", "低水位", "传感器异常"];

/* 故障码 err（app_protocol.h APP_ERR_*） */
const FAULT_NAMES = [
  "",
  "水位传感器异常",       // 1 APP_ERR_LEVEL_BAD
  "排水超时",             // 2 APP_ERR_DRAIN_TIMEOUT
  "换水补水超时",         // 3 APP_ERR_WC_FILL_TIMEOUT
  "手动/独立补水超时",    // 4 APP_ERR_FILL_TIMEOUT
  "程序输出互锁异常",     // 5 APP_ERR_INTERLOCK
];

export default {
  name: "DevCardKD4",
  props: ["devdata"],
  data() {
    return {
      class_obj: this.set_card_color(),
    };
  },
  watch: {
    devdata: function () {
      this.class_obj = this.set_card_color();
    },
  },
  computed: {
    show_id() { return this.$store.state.show_id; },
    show_simple() { return this.$store.state.show_simple; },
    only_online() {
      if (this.$store.state.only_online === false) return true;
      else return this.devdata.status === "在线" ? true : false;
    },
    st() {
      const v = this.devdata.value;
      return v && v.st != null ? v.st : -1;
    },
    stName() {
      if (this.st < 0 || this.st >= ST_NAMES.length) return "--";
      return ST_NAMES[this.st];
    },
    stClass() {
      /* 故障优先：故障锁定及故障触发的安全回BC均标红（§20/§23.1） */
      if (this.st === 11 || this.faultCode > 0) return "row-value--danger";
      if (this.st === 1 || this.st === 2) return "row-value--normal";
      return "row-value--active";
    },
    level() {
      const v = this.devdata.value;
      return v && v.level != null ? v.level : -1;
    },
    levelName() {
      if (this.level < 0 || this.level >= LEVEL_NAMES.length) return "--";
      return LEVEL_NAMES[this.level];
    },
    levelClass() {
      if (this.level === 3) return "row-value--danger";
      if (this.level === 0) return "row-value--active";
      return "";
    },
    faultCode() {
      const err = this.devdata.err;
      if (Array.isArray(err) && err.length > 0 && err[0] !== 0) return err[0];
      return 0;
    },
    faultName() {
      if (this.faultCode > 0 && this.faultCode < FAULT_NAMES.length) {
        return FAULT_NAMES[this.faultCode];
      }
      return "";
    },
  },
  methods: {
    set_card_color() {
      if (this.devdata.status === "离线") {
        return { "card-off": true };
      }
      for (let i in this.devdata.err) {
        if (this.devdata.err[i] !== 0) {
          return { "card-warning": true };
        }
      }
      return { "card-on": true };
    },
    gotokd4page() {
      this.$router.push({
        name: "KD4page",
        query: { did: this.devdata.did },
      });
    },
  },
};
</script>

<style scoped>
.card-wrap {
  background: #ffffff;
  border-radius: 16px;
  padding: 14px 16px 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 6px 20px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s, box-shadow 0.2s;
  border-left: 4px solid #2dd4bf;
  cursor: pointer;
}

.card-wrap:active {
  transform: scale(0.98);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
}

.card-on { border-left-color: #2dd4bf; }
.card-off { border-left-color: #cbd5e1; opacity: 0.7; }
.card-warning { border-left-color: #fb7185; }

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.card-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
}

.card-icon {
  font-size: 22px;
  color: #2dd4bf;
  flex-shrink: 0;
}

.card-off .card-icon,
.card-warning .card-icon {
  color: #94a3b8;
}

.card-name {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-group-tag {
  font-size: 10px;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
  flex-shrink: 0;
  font-weight: 500;
}

.card-header-right {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 8px;
}

.card-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.dot-online { background: #2dd4bf; }
.dot-offline { background: #94a3b8; }

.card-status-text {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

.card-body {
  padding: 4px 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 4px;
}

.card-row--last { padding-bottom: 2px; }

.row-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
}

.row-value {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
}

.row-value--normal { color: #2dd4bf; }
.row-value--active { color: #0ea5e9; }
.row-value--danger { color: #fb7185; }

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #f1f5f9;
  padding-top: 8px;
  margin-top: 4px;
}

.footer-left {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.footer-id {
  font-size: 11px;
  color: #cbd5e1;
  font-weight: 400;
}

.footer-time {
  font-size: 11px;
  color: #cbd5e1;
  font-weight: 400;
}
</style>
